import React from 'react'

const SVG = ({
  style = { fill: '#0696d7' },
  viewBox = '0 0 24 24',
  width = '24',
  height = '24',
  className = '',
  ...rest
}) => (
  <svg
    width={width}
    style={style}
    height={height}
    className={className}
    xmlns='http://www.w3.org/2000/svg'
    viewBox={viewBox}
    xmlnsXlink='http://www.w3.org/1999/xlink'
    {...rest}
  >
    <g transform='translate(0 -12.899)'>
      <path d='M320.767 546.1l-1.467 1.2 3.867 3.733 8.133-8-1.2-1.333-6.933 6.8z' transform='translate(-313.301 -521.468)' />
      <path d='M326.8 538.067a10.133 10.133 0 1 1-10.133 10.133 10.129 10.129 0 0 1 10.133-10.133m0-1.867a12 12 0 1 0 12 12 11.95 11.95 0 0 0-12-12z' transform='translate(-314.801 -523.301)' />
    </g>
  </svg>
)
export default SVG
